import type { ReactNode } from 'react'
import { type PropsWithChildren } from 'react'
import { MenuItem } from '@headlessui/react'
import { twMerge } from 'tailwind-merge'

interface ActionMenuItemProps extends PropsWithChildren {
  onClick?: () => void
  className?: string
}

// TODO: inline
export default function ActionsMenuItem(props: ActionMenuItemProps): ReactNode {
  return (
    <MenuItem
      className={twMerge(
        `flex w-full cursor-pointer items-center gap-1.5 px-5 py-2 text-start text-sm whitespace-nowrap text-text-primary hover:text-text-primary/70 data-focus:text-text-primary/70`,
        props.className,
      )}
      as="button"
      onClick={props.onClick}
    >
      {props.children}
    </MenuItem>
  )
}
